export function isApplicationResponse(maybeSession) {
    var _a, _b, _c;
    const getUrls = ['/users/application'];
    const patchUrls = ['applications/'];
    const method = (_b = (_a = maybeSession.config) === null || _a === void 0 ? void 0 : _a.method) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    const url = (_c = maybeSession.config) === null || _c === void 0 ? void 0 : _c.url;
    return (!!url &&
        maybeSession.status === 200 &&
        ((getUrls.includes(url) && method === 'get') || (patchUrls.some(u => url.includes(u)) && method === 'patch')));
}
